module.exports = __webpack_public_path__ + "img/GAME_BEAUTIFULFLOWER2.0397e103.jpg";